import React from "react";
import { GameContext } from "../../context/GameContext";
import useResponsive from "../../hooks/useResponsive";
import SpeechSynthesis from "./SpeechSynthesis";

const Question = React.memo(() => {
  const { currentQuestion, questionsArray } = React.useContext(GameContext);
  const { Mobile } = useResponsive();

  return (
    <>
      <h1 className="question_title">{questionsArray[currentQuestion].name}</h1>
      <SpeechSynthesis text={questionsArray[currentQuestion].question} />
      <p className="question_text">
        {questionsArray[currentQuestion].question}
      </p>
      <Mobile>
        <div className="question_image">
          {questionsArray[currentQuestion].img && (
            <img
              src={questionsArray[currentQuestion].img}
              alt={questionsArray[currentQuestion].name}
            />
          )}
        </div>
      </Mobile>
    </>
  );
});

export default Question;
